export interface LineupPlayerLike {
  name: string;
  nameAndId?: string;
}

export interface SlateProjectionLike {
  nameAndId: string;
}

/**
 * Lineup players whose nameAndId is not in the slate's loaded projections. A lineup carried over from another
 * slate keeps that slate's ids, and the same player has a different id on every slate. An empty projection list
 * means nothing has loaded yet, so nothing is flagged.
 */
export const playersNotOnSlate = (players: LineupPlayerLike[], projections: SlateProjectionLike[]): LineupPlayerLike[] => {
  if (!projections?.length) return [];
  const onSlate = new Set(projections.map((projection) => projection.nameAndId));
  return (players ?? []).filter((player) => player.nameAndId && !onSlate.has(player.nameAndId));
};

export const notOnSlateMessage = (players: LineupPlayerLike[]): string =>
  `Not on this slate: ${players.map((player) => player.name).join(', ')}. Remove them and re-add them from this slate's player list.`;
